/**
 * SET-43: the Flight Alert tab's retroactive-update control.
 *
 * PROGRESSIVE DISCLOSURE, AND THREE DEPARTURES FROM PRODUCTION - decision S46.
 *
 * Production draws "Update flight alert settings on existing reservations" mid-form, reveals it
 * on the first change to any of the seven toggles, and PRE-TICKS it. So an advisor adjusting a
 * default for future bookings silently rewrites the alerts on every booking they already have,
 * changing what their clients receive; undoing it means setting the toggles back and running it
 * again. Unchecked and missed, existing bookings simply keep their current alerts. The
 * recoverable mistake is the right default.
 *
 * What this file does differently:
 *   1. REVEALS IT UNCHECKED.
 *   2. PUTS THE COUNT IN THE LABEL - "Apply to my 23 upcoming air bookings" rather than the
 *      scale-free "existing reservations" - and fetches that count ON REVEAL, so an advisor who
 *      changes nothing never pays for the query.
 *   3. NO CONFIRMATION. With the box unchecked, ticking it is itself the deliberate act, and the
 *      surface does not double-confirm. (Production has none either: AgentsSettingsForm declares
 *      no confirm(), so the S23 two-pass prompt never fires there.)
 *
 * IT DOES NOT TOUCH AgentsSettingsForm.js. That file's handleFlightAlertFields() binds to
 * #updateAllFlightAlertsSection and pre-ticks the box; it is shared with the legacy screen and
 * stays exactly as it is. The pane names its container differently, so that selector finds
 * nothing in the modal.
 */

(function MySettingsFlightAlert($, Adzuki)
{
	"use strict";

	var COUNT_URL = '/MySettings/flightAlertCount',
	    fetched   = false;

	/**
	 * Names the number once it is known. Until then the label reads without one rather than
	 * showing a zero or a spinner - the control is already meaningful without the count, and a
	 * failed lookup must not make it look as though there is nothing to apply to.
	 */
	function _label(count)
	{
		var $label = $('#my-settings-update-all-label'),
		    noun;

		if (!$label.length || count === null) {
			return;
		}

		noun = (count === 1 ? 'upcoming air booking' : 'upcoming air bookings');

		$label.text('Apply to my ' + count + ' ' + noun);
	}

	function _reveal()
	{
		var $container = $('#my-settings-update-all');

		if (!$container.length || !$container.hasClass('hidden')) {
			return;
		}

		$container.removeClass('hidden');

		// ONCE PER PANEL RENDER. The count cannot change while the advisor is on this tab, and
		// the control stays revealed once shown, so a second fetch would buy nothing.
		if (fetched) {
			return;
		}

		fetched = true;

		Adzuki.Ajax.get(COUNT_URL).then(function counted(response) {
			if (response && response.data && typeof response.data.count !== 'undefined') {
				_label(parseInt(response.data.count, 10));
			}
		});
	}

	$(document).ready(function documentReady() {
		// DELEGATED FROM document, because the pane arrives with a panel render and is replaced by
		// the next one. Namespaced so a re-bind cannot stack handlers.
		$(document)
			.off('change.set43', '.flight-alert-default')
			.on('change.set43', '.flight-alert-default', function onDefaultChanged() {
				_reveal();
			});

		// A FRESH PANEL IS A FRESH CONTROL - hidden again, and the count worth fetching again. The
		// server renders it hidden, so this only has to forget the count.
		//
		// EXCEPT AFTER A HALF-FAILED APPLY, WHEN HIDING IT IS THE WORST THING TO DO. A save
		// re-renders the panel, which took the control away at exactly the moment the advisor had
		// been told some of their bookings were not updated - leaving them a warning and no way to
		// act on it. Their settings are unchanged and already stored, so ticking it again and
		// saving is precisely the retry, and the control has to be there to tick.
		$(document).on('my-settings:rendered', function panelRendered() {
			fetched = false;

			if (
				Adzuki.MySettings && Adzuki.MySettings.Save
				&& typeof Adzuki.MySettings.Save.status === 'function'
				&& Adzuki.MySettings.Save.status() === 'partial'
			) {
				_reveal();
			}
		});
	});
}(jQuery, window.Adzuki = window.Adzuki || {}));